import {Card, Modal} from 'antd';
import cn from 'classnames';
import React, {useEffect, useState} from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {Form} from 'components/form/form';
import {Spinner} from 'components/spinner';
import {ITableActionProps} from 'components/table/action';
import {ActionButton} from 'components/table/action/action-button/action-button';
import {loadMetadata, selectMetadata} from 'entities/metadata';
import {ReactComponent as CloseIcon} from 'shared/assets/close.svg';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {
    IEntityFileUploadState,
    selectDocumentFileUpload,
    setFileList,
} from 'store/slices/documents-uploading-slice';

interface IOwnProps extends ITableActionProps {
}

export const ButtonSetCorrectionNumber = ({
    wrapper, meta, entityName, ...props
}: IOwnProps) => {
    const dispatch = useAppDispatch();
    const metadata = useAppSelector(
        state => selectMetadata(meta?.modalEntityName || '', EEntityType.FORM)(state),
    );
    const fileUpload = useAppSelector(
        state => selectDocumentFileUpload(state)[entityName] as IEntityFileUploadState,
    );
    const files = fileUpload?.fileList;
    const {activityList} = fileUpload;

    const Component = wrapper || ActionButton;
    const [visible, setVisible] = useState(false);

    const handleSubmit = (formData: Record<string, any>) => {
        if (formData?.correctionNumber === undefined || !files?.length) return;

        const updatedFiles = files.map(file => {
            const permission = activityList[file.fileName]?.editFieldsPermission;
            const isDisabled = permission?.correctionNumber?.activated === false;
            return isDisabled ? file : {...file, correctionNumber: formData.correctionNumber};
        });

        dispatch(setFileList({entityName, fileList: updatedFiles}));
        setVisible(false);
    };

    useEffect(() => {
        if (!metadata) {
            dispatch(loadMetadata(meta?.modalEntityName || '', EEntityType.FORM));
        }
    }, []);

    const isLoaded = !!metadata;
    const cardTitle = metadata?.title;
    return (
        <>
            <Component
                {...props}
                onClick={() => setVisible(true)}
                disabled={!files?.length}
            >
                {meta.actionIcon && ((
                    <DynamicIcon
                        className="table-action__svg-icon"
                        type={meta.actionIcon}
                    />
                ))}
                {meta.actionTitle}
            </Component>
            <Modal
                className="form-modal"
                footer={null}
                visible={visible}
                width={980}
                onCancel={() => setVisible(false)}
                maskClosable={false}
                closeIcon={<CloseIcon className={cn('modal-close-icon', 'with-title')} />}
                destroyOnClose
            >
                {isLoaded
                    ? (
                        <Form
                            meta={metadata}
                            cardTitle={cardTitle}
                            entityName={entityName}
                            onClose={() => setVisible(false)}
                            actionForForm={(...args) => handleSubmit(args[3])}
                        />
                    ) : <Card style={{paddingTop: 20}}> <Spinner /></Card>}
            </Modal>
        </>
    );
};
